if (!customElements.get('pickup-availability')) {
  customElements.define(
    'pickup-availability',
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();

        if (!this.hasAttribute('available')) return;

        this.errorHtml = this.querySelector('template').content.firstElementChild.cloneNode(true);
        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        this.fetchAvailability(this.dataset.variantId);
      }

      fetchAvailability(variantId) {
        let rootUrl = this.dataset.rootUrl;
        if (!rootUrl.endsWith('/')) {
          rootUrl = rootUrl + '/';
        }
        const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

        fetch(variantSectionUrl)
          .then((response) => response.text())
          .then((text) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('.shopify-section');
            this.renderPreview(sectionInnerHTML);
          })
          .catch((e) => {
            const button = this.querySelector('button');
            if (button) button.removeEventListener('click', this.onClickRefreshList);
            this.renderError();
          });
      }

      onClickRefreshList(evt) {
        this.fetchAvailability(this.dataset.variantId);
      }

      update(variant) {
        if (variant?.available) {
          this.fetchAvailability(variant.id);
        } else {
          this.removeAttribute('available');
          this.innerHTML = '';
        }
      }

      renderError() {
        this.innerHTML = '';
        this.appendChild(this.errorHtml);

        this.querySelector('button').addEventListener('click', this.onClickRefreshList);
      }

      renderPreview(sectionInnerHTML) {
        const drawer = document.querySelector('pickup-availability-drawer');
        if (drawer) drawer.remove();
        if (!sectionInnerHTML.querySelector('pickup-availability-preview')) {
          this.innerHTML = '';
          this.removeAttribute('available');
          return;
        }

        this.innerHTML = sectionInnerHTML.querySelector('pickup-availability-preview').outerHTML;
        this.setAttribute('available', '');
        this.fillPickupTime();

        document.body.appendChild(sectionInnerHTML.querySelector('pickup-availability-drawer'));
      }

      fillPickupTime() {
        const prefix = ['v nedeľu','v pondelok','v utorok','v stredu','vo štvrtok','v piatok','v sobotu'];

        function fmt(d) {
          return d.getDate() + '.' + (d.getMonth() + 1) + '.';
        }

        function toMinutes(hhmm) {
          const [h, m] = hhmm.split(':').map(Number);
          return h * 60 + m;
        }

        const pickupEl = this.querySelector('[data-store-pickup-time]');
        if (!pickupEl) return;

        const hoursEl = this.querySelector('[data-store-hours]');
        let hoursMap = {};
        if (hoursEl) {
          try {
            hoursMap = JSON.parse(hoursEl.dataset.storeHours);
          } catch (e) {
            hoursMap = {};
          }
        }

        const now = new Date();
        const currentDay = now.getDay();
        const currentMinutes = now.getHours() * 60 + now.getMinutes();

        // Pickup today only if the store is open right now AND more than 1h
        // remains until closing. Otherwise (closed, outside hours, or the
        // midnight-to-opening window) push to the next open day.
        let pickupDate = null;
        const today = hoursMap[currentDay];
        if (today && !today.closed) {
          const opensMin = toMinutes(today.opens);
          const closesMin = toMinutes(today.closes);
          if (currentMinutes >= opensMin && closesMin - currentMinutes > 60) {
            pickupDate = new Date(now);
          }
        }

        if (!pickupDate) {
          for (let i = 1; i <= 7; i++) {
            const d = (currentDay + i) % 7;
            const dayHours = hoursMap[d];
            if (dayHours && !dayHours.closed) {
              pickupDate = new Date(now);
              pickupDate.setDate(pickupDate.getDate() + i);
              break;
            }
          }
        }

        if (!pickupDate) return;

        const tomorrow = new Date(now);
        tomorrow.setDate(tomorrow.getDate() + 1);

        if (pickupDate.toDateString() === now.toDateString()) {
          pickupEl.textContent = 'dnes ' + fmt(pickupDate);
        } else if (pickupDate.toDateString() === tomorrow.toDateString()) {
          pickupEl.textContent = 'zajtra ' + fmt(pickupDate);
        } else {
          pickupEl.textContent = prefix[pickupDate.getDay()] + ' ' + fmt(pickupDate);
        }
      }
    }
  );
}

if (!customElements.get('pickup-availability-drawer')) {
  customElements.define(
    'pickup-availability-drawer',
    class PickupAvailabilityDrawer extends BasicModal {
      constructor() {
        super();
      }
    }
  );
}
